import React, { Component } from 'react';
import { useState } from 'react';
import FixedView from '../../FixedView';
import ColumnItem from './ColumnItem';
import { checkTranslation, setObject } from '../../../utils/useful';
import tableComponents from '../../tableComponents'

class ColumnHeader extends Component {
    constructor(props) {
        super(props)
        this.inputRef = React.createRef();
    }


    state = {
        showattachment: false,
        rename: false,
        MoreOptions: false,
        prev: false,
        moreOoption: [
            { title: "Add rule to section", icon: "/assets/icons/bolt.svg" },
            { title: "Rename section", icon: "/assets/icons/highlighter.svg" },
            { title: "Add section", icon: "/assets/icons/line.3.horizontal.decrease.svg" },
            // { title: "Delete section", icon: "/assets/icons/trash.svg" },
        ],

    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ loadFixedView: true })
        }, 100);
    }

    OnMoreOption = (item) => {
        if (item == 'Add section')
            this.props.addNewColumn()
        if (item == 'Rename section')
            this.renameSection()
        if (item == 'Add rule to section')
            this.renameSection()

    }
    componentDidUpdate() {
        if (this.state.rename) {
            document.addEventListener('keypress', this.onKeyPress)
        }
    }

    onKeyPress = (event) => {
        if (event.key === "Enter") {
            // console.log("Enter Key Press");
            document.removeEventListener('keypress', this.onKeyPress);
            const newName = this.inputRef.current.value;
            // this.props.onRenameItem(newName)
            console.log(newName)
            this.setState({ rename: false })
        }
    }
    openmoremenu = () => {
        this.more.showView()
    }
    onDoubleClickHandler = () => {
        if (this.clickTimeOut !== null) {
            // console.log('double clickkkkkkk')
            clearTimeout(this.clickTimeOut)
            this.clickTimeOut = null;
            return;
        }
        this.clickTimeOut = setTimeout(() => {
            clearTimeout(this.clickTimeOut)
            this.clickTimeOut = null;
        }, 1000);
        this.setState({ addSubject: true })
        this.renameSection()
    };
    renameSection = () => {
        this.setState({ rename: true })
    }


    addRecord = () => {

        let newData = {}
       
        setObject(newData, this.props.column?.headerInfo?.headerKey, this.props.column?.columnHeader)
        
        this.props.functionsHandler('collection', 'addRecord', newData)
    }


    render() {
        const { headerInfo, fullData } = this.props
        // console.log('info===', headerInfo)
        let tColor = headerInfo['textColor' + headerInfo?.id]
        let bColor = headerInfo['backColor' + headerInfo?.id]
        let image = headerInfo['backColor' + headerInfo?.id]

        // console.log(this.props.column)
        // console.log(headerInfo)

        let Component = tableComponents[headerInfo.type]

        // console.log('this.props.headerInfo', this.props.headerInfo)
        // console.log(headerInfo,fullData,this.props.columnHeader,headerInfo.type)

        return (
            <div className=''>
                <div className="column-header flexcb " {...this.props.dragpHand}>
                    <div className="header-name d-flex" style={{ color: tColor, background: bColor, borderRadius: '20px', padding: '3px 5px', fontSize: 14 }}>
                        {/* {console.log('this.props.columnHeader', this.props)} */}
                        {Component && (
                            <Component header={headerInfo} fullData={fullData} data={this.props.columnHeader} />
                        )}

                        {/* {!this.state.rename ? */}
                        {/* <div className="font-size-14 text-semibold" style={{}} onClick={() => this.onDoubleClickHandler()}>{checkTranslation(this.props.columnHeader)}</div> */}
                        {/* :
                            <input type="text" className='br-4' style={{ border: "none", padding: "5px" }} placeholder={"new name..."} defaultValue={this.props.columnHeader} ref={this.inputRef} />
                        } */}
                        <div className='flexcc'>
                            <div className='br-20 flexcc mld-3' style={{ background: this.props.colors?.background ?? '#000', height: 19, minWidth: 19 }}>
                                <span className="text-smaller number text-semibold white" style={{ lineHeight: 0 }}>{this.props.columnItemsLength}</span>
                            </div>
                        </div>
                    </div>
                    <div className='flexc'>
                        <div className="extra-options ">
                            <button className='flexcc more-box br-5 ' onClick={() => this.addRecord()} >
                                <img width={22} src="/assets/icons/plus-black.svg" />
                            </button>
                        </div>
                        {/* <div className="extra-options" ref={el => this.moreOption = el}>
                            <button className='flexcc more-box br-5 ' onClick={() => this.openmoremenu()}>
                                <img width={22} src="/assets/icons/more-black.svg" />
                            </button>
                        </div> */}
                    </div>
                </div>
                <FixedView ref={el => this.more = el} nodeRef={this.moreOption} showFocus={false} topOffset={7} xOffset={140} zIndex={300}>
                    <div className='shadow-2 br-10 py-1 px-2' style={{ backgroundColor: "#fff", width: "180px" }}>
                        {this.state.moreOoption.map((prop, index) => {
                            return (
                                <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5'
                                    onClick={() => this.OnMoreOption(prop.title)}>
                                    <img className='mrd-3 flexcc' src={prop.icon} />
                                    <p className='text-start des-color'>{prop.title}</p>
                                </button>
                            )
                        })}
                        <div className='mx-2' style={{ borderTop: "1px solid #c8c8c8" }}>
                        </div>
                        <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5' >
                            <img className='mrd-3 flexcc' src='/assets/icons/trash.svg' />
                            <p className='text-start' style={{ color: "#EF1919" }} onClick={() => this.props.removeNewColumn()}>Delete section</p>
                        </button>
                    </div>
                </FixedView>

            </div>
        )
    }
}

export default ColumnHeader;